import React, { Component } from "react";
import Paper from "@material-ui/core/Paper";
import { Link} from "react-router-dom";

export class PrivacyPolicyJPWorks extends Component {
  componentDidMount() {
    document.title = "JP-Works - Privacy Policy";
  }
  render() {
    return (
      <div>
        <h1 className="heading">Privacy Policy</h1>
        <h3 className="heading3">JP-Works Mobile Application</h3>
        <Paper className="paper" elevation={3}>
          <p>
            <b>
              Thank you for using JP-Works. Your privacy is important to us. To
              better protect your privacy, and to help ensure a rewarding
              experience for all users, we provide this privacy policy.
            </b>
          </p>
          <ol className="ol">
            <li>
              <b>Scope:</b>
              <p>
                <b>JP-Works</b> (hereinafter referred to as “App”, “we”, “our”, “us”)
                is committed to protecting and respecting your privacy.
              </p>
              <ol>
                <li>
                  This policy (this “Privacy Policy”), together with the Terms
                  and Conditions of the App outlines the App’s privacy practices
                  regarding the collection, use and safeguard of your
                  information through the App and the services offered
                  thereupon.
                </li>
                <li>
                  By using the App or registering or signing up for the App and
                  submission of personal information; or if you are a minor, the
                  submission of your personal information either by your parents
                  (or your guardian) or by you with the permission of your
                  parents (or guardian) to the App will be deemed as your
                  acceptance of this Privacy Policy.
                </li>
                <li>
                  The Terms are an electronic record in terms of the Information
                  Technology Act, 2000 (as amended / re-enacted) (“IT Act") and
                  rules thereunder, and is published in accordance with the
                  provisions of Rule 3 (1) of the Information Technology
                  (Guidelines for Intermediaries and Digital Media Ethics Code)
                  Rules, 2021, which mandates for publishing of rules and
                  regulations, privacy policy and terms of use for access or
                  usage of App. This electronic record is generated by a
                  computer system and does not require any physical or digital
                  signatures.
                </li>
              </ol>
            </li>
            <li>
              <b>Changes to the Privacy Policy:</b>
              <ol>
                <li>
                  We are obligated to protect your information in accordance
                  with applicable laws, and regulations.
                </li>
                <li>
                  This Privacy Policy is subject to modification based on
                  changes in the business, legal and regulatory requirements and
                  will be updated online. We will notify you whenever any change
                  to the Privacy Policy are made. You are encouraged to
                  periodically visit this page to review the Privacy Policy and
                  any changes to it.
                </li>
              </ol>
            </li>
            <li>
              <b>Third Party Services:</b>
              <ol>
                <li>
                  Please note that your mobile service provider, internet
                  service provider, mobile operating system provider, third
                  party applications including the applications pre-loaded on
                  your smart phones powered by Android platform or customized
                  Android ROM (“Device”), websites that you access, third party
                  operators may also collect, use and share information about
                  you and your usage. We cannot control how these third parties
                  collect, use, share or secure this information. For
                  information about third-party privacy practices, please
                  consult their respective privacy policies.
                </li>
              </ol>
            </li>
            <li>
              <b>Personal Information we collect:</b>
              <ol>
                <li>
                  Personal information is defined as information that can be
                  used to identify you and may include details such as your
                  name, age, gender, contact information, products and services
                  you are interested in or require more information about.
                  Insofar as sensitive personal information is concerned, it
                  will carry the meaning as may be defined by applicable laws
                  from time to time.
                </li>
                <li>
                  The following is the manner in which we collect, use, share
                  and retain personal information:
                  <ol>
                    <li>
                      Collection:
                      <ol>
                        <li>
                          You agree that the App may collect such personal
                          information, whenever relevant, to help providing you
                          with information and to complete any transaction or
                          provide any product you have requested or authorized.
                          You also consent to the collection of certain personal
                          information in the course of your applying for the
                          products and/or services.
                        </li>
                      </ol>
                    </li>
                    <li>
                      Usage:
                      <ol>
                        <li>
                          The App seeks this information either to (i) validate
                          and process your request for the services of the App
                          or information; (ii) to improve the quality of the
                          App; (iii) to assist you to determine which services
                          best meet your needs; or (iv) to facilitate our
                          internal business operations, including the
                          fulfillment of any legal and regulatory requirements;
                          or (v) to provide you with recommendation about
                          services you may be interested in, based on your use
                          of the App; or (vi) to provide you with marketing
                          communications and advertising that the App believe
                          may be of interest of you ; or (vii) to facilitate
                          your purchases.
                        </li>
                      </ol>
                    </li>
                    <li>
                      Sharing:
                      <ol>
                        <li>
                          We may disclose personal information to our affiliates
                          when necessary to perform services on our behalf or on
                          your behalf, to provide display advertising and
                          promotional services, providing search results and
                          links (including paid listings and links), providing
                          customer service etc.
                        </li>
                        <li>
                          We may also share personal information with external
                          organizations or individuals if we believe that
                          access, use, preservation or disclosure of the
                          information is reasonably necessary to: (a) meet any
                          applicable law, regulation, legal process or
                          enforceable governmental request; (b) detect, prevent
                          or otherwise address fraud, security or technical
                          issues; (c)protect against harm to the rights,
                          property or safety of our customers or the public, as
                          required or permitted by law.
                        </li>
                      </ol>
                    </li>
                    <li>
                      Retention:
                      <ol>
                        <li>
                          The information so collected shall be retained only
                          for a limited duration necessary to fulfil the
                          purposes outlined herein unless a longer retention
                          period is required or permitted by law and only for
                          the purposes defined above. Once the purpose is
                          achieved, all personal information is deleted in a
                          safe and secure mode.
                        </li>
                      </ol>
                    </li>
                  </ol>
                </li>
              </ol>
            </li>
            <li>
              <b>Non-Personal Information:</b>
              <ol>
                <li>
                  Non-personal information is defined as any data that does not
                  personally identify you and may include unique system or
                  hardware identifiers, system or App software, and peripherals.
                </li>
                <li>
                  Any non-personal information, when clubbed with personal
                  information shall be treated as personal information.
                </li>
                <li>
                  The following is the manner in which we collect, use, share
                  and retain non-personal information.
                  <ol>
                    <li>
                      Collection:
                      <ol>
                        <li>
                          You agree that the App may collect diagnostic,
                          technical, usage related information, for the usage
                          purposes described below.
                        </li>
                      </ol>
                    </li>
                    <li>
                      Usage:
                      <ol>
                        <li>
                          The above mentioned information is gathered
                          periodically to provide and improve the App and
                          services therein, facilitate the provision of App
                          support and other services to you (if any) and to
                          verify compliance with the terms of this Policy.
                        </li>
                      </ol>
                    </li>
                    <li>
                      Sharing:
                      <ol>
                        <li>
                          To enable the App partners to improve their software,
                          hardware and services designed for use with the App,
                          we may also provide any such partner with a subset of
                          diagnostic information that is relevant to that
                          partner’s software, hardware and/or services, as long
                          as the diagnostic information is in a form that does
                          not personally identify you.
                        </li>
                      </ol>
                    </li>
                    <li>
                      Retention:
                      <ol>
                        <li>
                          The information so collected shall be retained only
                          for a limited duration necessary to fulfil the
                          purposes outlined herein unless a longer retention
                          period is required or permitted by law and only for
                          the purposes defined above. Once the purpose is
                          achieved, all information is deleted in a safe and
                          secure mode.
                        </li>
                      </ol>
                    </li>
                  </ol>
                </li>
              </ol>
            </li>
            <li>
              <b>Location Services:</b>
              <ol>
                <li>
                  The App, its licensees and agents, may access, collect and
                  analyse your usage of the App and other information related to
                  your location on a regular basis through Bluetooth and Wi-Fi
                  signals and other technologies and data for the performance of
                  the services provided by the App and to help improve the
                  design, functionality, performance, and content of the App. In
                  order to collect geo-location information, the location
                  settings must be enabled on your device. Therefore, in some
                  cases, the App may request that you enable the location
                  settings.
                </li>
                <li>
                  Except in cases where any specific services requested by you
                  require or involve personal identification, the App collects
                  location data anonymously and in a form that does not
                  personally identify you. By using the App, you agree and
                  consent to transmission, collection, maintenance, processing
                  and use of your location data to provide and improve such
                  services of the App.
                </li>
              </ol>
            </li>
            <li>
              <b>Cookies:</b>
              <ol>
                <li>
                  Information collected by cookies and other technologies are
                  treated as non-personal information. However, to the extent
                  that IP addresses or similar identifiers are considered
                  personal information by local law, we treat any information
                  linked to such identifiers as personal information. Similarly,
                  to the extent that non-personal information is combined with
                  personal information, we will treat the combined information
                  as personal information.
                </li>
              </ol>
            </li>
            <li>
              <b>Other Information the App collects:</b>
              <ol>
                <li>
                  The App also may collect other information about you in ways
                  that the App describe to you or otherwise with your consent.
                  You can choose not to provide us with certain types of
                  information, but doing so may affect your ability to avail
                  and/or use some services.
                </li>
              </ol>
            </li>
            <li>
              <b>Third Party Applications, Websites & Services:</b>
              <ol>
                <li>
                  The App may include links to other websites/Apps and other
                  content that links to third party websites. Such websites/Apps
                  are governed by their respective privacy policies, which are
                  out of the App’s control. Use of any information you provide
                  while using a third party website or App through the App, is
                  governed by the privacy policy of the operator of the website
                  / App / operator you are using/ visiting. That policy may
                  differ from that of the App. If you can't find the privacy
                  policy of any of such websites /App via a link from its
                  website's homepage, you should contact the relevant website
                  /App operator directly for more information.
                </li>
              </ol>
            </li>
            <li>
              <b>Access, Correction and Deletion:</b>
              <ol>
                <li>
                  The App strives hard to keep its records updated and accurate
                  with your latest information. You shall be responsible to
                  ensure that the information or data you provide from time to
                  time is and shall be correct, current and updated and you have
                  all the rights, permissions and consents to provide such
                  information or data.
                </li>
                <li>
                  You may note that deletion of certain information that is
                  crucial for performance of services by the App or withdrawal
                  of consent may lead to cancellation of your access to the App
                  or your access to certain features and services of the App.
                  Additionally, we may not be able to process your request of
                  correction, updating or deletion, in case the same is not
                  supported by valid documents or data retention is required by
                  the applicable law or law enforcement requests or under any
                  judicial proceedings or it is extremely difficult to implement
                  (such as requests related to backup copies or if a new system
                  is required to process the request or change of technical
                  design) or risks the privacy of other users.
                </li>
              </ol>
            </li>
            <li>
              <b>Queries and Complaints:</b>
              <ol>
                <li>
                  We are committed to protect your personal information
                  collected and processed by us and look forward to your
                  continued support for the same. In case of any feedback or
                  concern regarding protection of your personal information, or
                  any privacy-related feedback or concerns you may contact:
                  {/* <div className="contact-details">
                    <p>
                      Email: <a href="mailto:"></a>
                    </p>
                    <p>
                      Contact No: <a href="tel:"></a>
                    </p>
                  </div> */}
                </li>
              </ol>
            </li>
          </ol>
          <div className="footer-links">
              <span>
                <Link to="/terms-conditions-JP-Works">Terms & Conditions</Link>
              </span>
              <span id="privacy-policy">
                <Link to="/privacy-policy-JP-Works">Privacy Policy</Link>
              </span>
            </div>
            <p className="copy-right">
              <p>
                Copyright © {new Date().getFullYear()} JP-Works Mobile Application.
              </p>
              <p>All rights reserved.</p>
            </p>          
        </Paper>
      </div>
    );
  }
}

export default PrivacyPolicyJPWorks;
